<template>
    <div class="finance-details">
        <div class="row justify-content-md-left">
            <div class="col-12 col-lg-6 finance-details__cost">
                <span class="finance-details__cost__heading">Leasing cost per month</span>
                <span class="finance-details__cost__value">{{financeCostCalculated | toCurrency}}</span>
            </div>
            <div class="col-12 col-lg-6 finance-details__details">
                <div class="row">
                    <div class="col">
                        <div class="finance-details__list">
                            <div class="finance-details__item finance-details__item--title">
                                Excess mileage fee: <span class="info" tabindex="-1" id="excess-tt"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><g fill="none" fill-rule="nonzero"><circle cx="11" cy="11" r="10.214" fill="#FFF" stroke="#66E4EE" stroke-width="1.571"/><path fill="#004666" d="M10 8h2v10h-2zM10 4h2v2h-2z"/></g></svg></span>
                                <b-popover :target="`excess-tt`" :placement="`top`" triggers="hover focus">
                                    <p> Payable if you exceed the mileage in your contract. </p>
                                </b-popover>
                            </div>
                            <div class="finance-details__item">
                                <span class="finance-details__details__value">{{excessCost}}p</span>
                            </div>

                            <div class="finance-details__item finance-details__item--full">
                                <div class="d-flex finance-details__item finance-details__item--title">
                                    <div>
                                        Including: <span class="info" tabindex="-1" id="include-tt"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><g fill="none" fill-rule="nonzero"><circle cx="11" cy="11" r="10.214" fill="#FFF" stroke="#66E4EE" stroke-width="1.571"/><path fill="#004666" d="M10 8h2v10h-2zM10 4h2v2h-2z"/></g></svg></span>&nbsp;
                                        <b-popover :target="`include-tt`" :placement="`top`" triggers="hover focus">
                                            <p> The elements that make up the leasing cost. Finance is the vehicle; service is
                                                everything else. Service will always include RAC Breakdown cover. If you have chosen
                                                to include maintenance this will also be incorporated here. </p>
                                        </b-popover>
                                        <br>
                                        Service <br>
                                        Finance
                                    </div>
                                </div>
                                <div class="finance-details__item">
                                    &nbsp;<br>
                                    <span class="finance-details__details__value">{{maintCost | toCurrency}}</span><br>
                                    <span class="finance-details__details__value">{{financeCost | toCurrency}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "FinanceDetails",
        data() {
            return {
                leasingCost: 500,
                excessMileage: 50,
                service: 20,
                finance: 20,
                staticServicePart: this.$store.state.SERVICE_COST
            }
        },
        computed: {
            selectedFinance: function() {
                return this.$store.getters.selectedOffer;
            },
            financeCost: function() {
                if (this.selectedFinance) {
                    return this.selectedFinance.finance;
                }
                return null;
            },
            excessCost: function() {
                if (this.selectedFinance) {
                    return this.selectedFinance.excess;
                }
                return null;
            },
            maintCost: function() {
                if (this.selectedFinance) {
                    return (this.$store.state.FINANCE_FILTER_MAINT) ? this.selectedFinance.service : this.staticServicePart;
                }
                return null;
            },
            financeCostCalculated: function () {
                if (this.selectedFinance) {
                    return this.selectedFinance.finance + this.maintCost;
                }
                return null;
            },
        },
    }
</script>

<style scoped lang="stylus">
    .finance-details
        padding 18px 20px 25px
        background-color #004666
        color #ffffff
        font-family: "VWAGTheSansRegular", Arial, sans-serif;
        &__cost
            @media(min-width: 991px)
                padding-right 150px
            &__heading
                font-size 28px
                line-height 36px
                display block
            &__value
                margin 5px 0 0 0
                font-size 48px
                line-height 48px
                font-family: "VWAGTheSansBold", Arial, sans-serif;
                display block
        &__details
            font-size 18px
            font-family: "VWAGTheSansRegular", Arial, sans-serif;
            &__value
                font-family: "VWAGTheSansBold", Arial, sans-serif;

        &__list
            display flex
            flex-wrap wrap

        &__item
            flex 0 0 100%
            max-width 50%

            @media(max-width 480px)
                max-width 25%

            &--title
                padding-right 15px

                @media(max-width 480px)
                    max-width 75%

            &--full
                max-width 100%
                display flex
                flex-wrap wrap

</style>